import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/ASH103mid21.pdf'
import cse from '../assets/ASH103end21.pdf'

export default function Peng() {
  return (
    <div>
       <Subject title="Preparatory Engilish(ASH103)" mid="Q. Paper"
    book1="Practical English Usage. Michael Swan. OUP. 1995." book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=36596787&h=edbc32fbe2b65d47b7e511ebad00876d&u=cache&ext=pdf"
     book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}